import "./VisasAndImmigration.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import HopeBeginsWithBasket from "./sections/HopeBeginsWithBasket";
import ServicesOverview from "./sections/ServicesOverview";
import The3StepPatientJourney from "./sections/The3StepPatientJourney";
import Footer from "@/reusable_sections/Footer";
export default function VisasAndImmigrationPage() {
  return <div>
      <GatewayNavigation />
      <HopeBeginsWithBasket />
      <ServicesOverview />
      <The3StepPatientJourney />
      <Footer />
    </div>;
}